import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import chemisteryImg from "../../../../image/home/chemistery.png";
import { ContentWrapper, StyledButton, StyledSection } from "./styledGroupPurchase";

const GroupPurchaseSectionComponent = () => {
  return (
    <StyledSection>
      <Container>
        <Row>
          <Col>
            <ContentWrapper className="mx-auto">
              <p>
                با خرید <mark>اشتراک گروهی</mark>
                <br />
                می‌توانید دانش‌آموزان خود را به آزمایشگاه آنلاین بیاورید.
              </p>
              <StyledButton
                isLink
                to="/group-purchase"
                variant="secondary"
                className="align-self-end"
              >
                اشتراک گروهی
              </StyledButton>
            </ContentWrapper>
          </Col>
          <Col className="text-center">
            <img
              src={chemisteryImg}
              alt="آزمایشگاه شیمی"
              width="390"
              height="335"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </StyledSection>
  );
};

export default GroupPurchaseSectionComponent;
